import React from "react";
import PropTypes from "prop-types";
import { AttentionGrabber, Button, ChakraUIProvider, AutoLogout } from "@everfi/reactifi";
import Playlist from "../../bundles/admin/components/playlists/Playlist";
import InviteFormCustomization from "../../bundles/admin/components/customizations/InviteFormCustomization";
import QuestionForm from "../../bundles/admin/components/questions/QuestionForm";
import ExportTranslations from "../../bundles/admin/components/translations/ExportTranslations";
import DashboardFlexibleAreaCustomization from "../../bundles/admin/components/customizations/DashboardFlexibleAreaCustomization";

/**
 * Wraps component with ChakraUI in order to properly inject required styles
 * To add more supported components, import and include in components array
 * @param {object} props Component props
 */
const ChakraComponentWrapper = props => {
  const { comp, ...compProps } = props;
  const components = { AttentionGrabber, DashboardFlexibleAreaCustomization, Button, ExportTranslations, InviteFormCustomization, Playlist, QuestionForm, AutoLogout };
  const Component = components[comp];

  return (
    <ChakraUIProvider>
      <Component {...compProps} />
    </ChakraUIProvider>
  );
};

ChakraComponentWrapper.propTypes = {
  comp: PropTypes.string
};

export default ChakraComponentWrapper;
